<template lang="pug">
span.pill(:class='{ "pill--active": active, "pill--danger": danger }')
  icon(:name='icon' v-if='icon')
  span
    slot
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';

export default {
  name: 'InfoPill',
  components: {
    Icon,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    danger: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="stylus">
.pill
  display: inline-flex
  align-items: center
  gap: 0.4rem
  padding: 0.25rem 0.7rem
  border-radius: 20px
  font-size: 0.8rem
  font-weight: 600
  white-space: nowrap
  background-color: #F0F0F0
  color: #707070

  &--active
    background-color: #E7F0EF
    color: #19665B

  &--danger
    background-color: #F8D7DA
    color: #842029
</style>
